import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class PxLoadingSpinnerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PxLoadingSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PxLoadingSpinnerComponent, isStandalone: false, selector: "px-loading-spinner", inputs: { cssClass: "cssClass" }, ngImport: i0, template: "<div [class]=\"cssClass || 'rs-spinner'\"></div>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PxLoadingSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'px-loading-spinner', changeDetection: ChangeDetectionStrategy.OnPush, standalone: false, template: "<div [class]=\"cssClass || 'rs-spinner'\"></div>\n" }]
        }], propDecorators: { cssClass: [{
                type: Input
            }] } });

class LoadingSpinnerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: LoadingSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: LoadingSpinnerModule, declarations: [PxLoadingSpinnerComponent], imports: [CommonModule], exports: [PxLoadingSpinnerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: LoadingSpinnerModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: LoadingSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PxLoadingSpinnerComponent],
                    exports: [PxLoadingSpinnerComponent],
                    imports: [CommonModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LoadingSpinnerModule, PxLoadingSpinnerComponent };
